import { GameCategory } from '../enums';
import { MarketConfig } from '../interfaces';
import { basketballConfig } from './market/basketball.config';
import { footballConfig } from './market/football.config';
import { mlbConfig } from './market/mlb.config';
import { hockeyConfig } from './market/hockey.config';
import { soccerConfig } from './market/soccer.config';
import { golfConfig } from './market/golf.config';
import { tennisConfig } from './market/tennis.config';

export const marketConfigMap: Partial<Record<GameCategory, Record<string, MarketConfig>>> = {
	[GameCategory.NBA]: basketballConfig,
	[GameCategory.NCAAB]: basketballConfig,
	[GameCategory.NFL]: footballConfig,
	[GameCategory.NCAAF]: footballConfig,
	[GameCategory.MLB]: mlbConfig,
	[GameCategory.EPL]: soccerConfig,
	[GameCategory.UCL]: soccerConfig,
	[GameCategory.FIFA]: soccerConfig,
	[GameCategory.NHL]: hockeyConfig,
	[GameCategory.PGA]: golfConfig,
	[GameCategory.ATP]: tennisConfig,
	[GameCategory.WTA]: tennisConfig,
	[GameCategory.TENNIS]: tennisConfig,
};
